import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import messages from 'aurora-translations';
import ADGMTextField from '../../../ADGMTextField';

function TextField(props) {
  const { intl, label, placeholder, ...fieldProps } = props;

  return (
    <div>
      <ADGMTextField
        label={messages[label]?.id ? intl.formatMessage({ ...messages[label] }) : label}
        placeholder={messages[placeholder]?.id ? intl.formatMessage({ ...messages[placeholder] }) : placeholder}
        {...fieldProps}
      />
    </div>
  );
}

TextField.propTypes = {
  intl: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

TextField.defaultProps = {
  label: '',
  placeholder: '',
};

export default injectIntl(TextField);
